export default {
  title: '搜寻类似案件',
  desc: '点击以选择或排除与本判决书相关的标籤以作查询。',
  search_desc: '此搜寻将列出符合最多「包括」标籤的判决书。',
  lang_support: '此功能暂时只支援英语搜寻。',
  show_tree: '层递排列',
  hide_tree: '紧密排列',
  include: '包括',
  exclude: '排除',
  tag_indicator_help: '标签顔色有什麽意思？',
  tag_dark: '深色标签',
  tag_dark_exp: ' 代表判决书有直接提及该概念', 
  tag_light: '浅色标签', 
  tag_light_exp: ' 为与判决书相关的延伸概念',
  selected: '已选搜寻条件',
  result: '相关判决书',
  return_to_tags: '返回标籤选择',
  beta_hint:'判案书的标签是用AI技术生成的，请点击以阅读相关资讯。欢迎填写意见表格提供意见及回报错误。',
}